class NailArtMuseum {
  constructor(ids, options, swiper) {
    this.ids = ids
    this.box = document.querySelector(`.nail-art-museum--${ids}`)
    this.itemListData = []
    this.itemListTitle = []
    this.options = JSON.parse(options)
    this.swiper = swiper
    this.currentNumber = null
    this.init(swiper)
  }
  init (swiper) {
    const option = {
      direction: 'horizontal',
      loop: false,
      centerInsufficientSlides: true,
      slidesPerGroup: 1,
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: this.options.navigation ? {
        prevEl: `.nail-art_${this.ids}_p`,
        nextEl: `.nail-art_${this.ids}_n`
      } : {
        prevEl: null,
        nextEl: null
      },
      breakpoints: {
        1280: { //当屏幕宽度大于等于1280
          spaceBetween: this.options.spaceBetween,
          slidesPerView: this.options.slidesPerView
        }
      }
    }

    new swiper(`.nail-swiper--${this.ids}`, option)
    this.initItemAddEvent()
  }

  initItemAddEvent () {
    this.box.querySelectorAll('.swiper-slide').forEach((i, index) => {

      if( i.querySelector('div[data-nail-art-museum]')) {
        this.itemListData.push(JSON.parse(i.querySelector('div[data-nail-art-museum]').innerHTML))
        i.removeChild(i.querySelector('div[data-nail-art-museum]'))
      } else {
        this.itemListData.push('')
      }

      if (i.querySelector('div[data-nail-art-title]').innerHTML) {
        this.itemListTitle.push(i.querySelector('div[data-nail-art-title]').innerHTML)
      } else {
        this.itemListTitle.push('')
      }
      i.querySelector('.img-text').addEventListener('click', () => {
        this.btnEvent(i ,index)
      })
      i.querySelector('.launch-icon').addEventListener('click', () => {
        this.btnEvent(i ,index)
      })
    })
  }

  btnEvent(i, index) {
    if (this.currentNumber === index) {
      this.putAway()
      return
    }
    this.box.querySelectorAll('.swiper-slide').forEach(ii => {
      ii.querySelector('.launch-icon').classList.remove('active')
    })
    i.querySelector('.launch-icon').classList.add('active')
    this.initLaunchBox(this.itemListData[index], index)
    this.currentNumber = index
  }

  initLaunchBox (list, index) {
    if (!(list && list.length)) {
      return
    }
    const box = this.box.querySelector('.launch-box')
    box.style.display = 'block'
    box.innerHTML = ''
    const launchTitle = document.createElement('div')
    const launchContent = document.createElement('div')
    if (this.itemListTitle[index]) {
      launchTitle.innerHTML = this.itemListTitle[index]
      box.append(launchTitle)
    }
    launchTitle.className = 'launch-title'
    launchContent.className = 'launch-content'
    list.forEach(i => {
      const di = document.createElement('div')
      di.className = 'custom-image-box'
      di.style.paddingBottom = '100%'
      const img = document.createElement('img')
      img.className = 'placeholder-img lazyload'
      img.setAttribute('data-srcset', i.featured_image)
      img.setAttribute('data-image', '')
      img.src = ''
      const title = document.createElement('div')
      title.className = 'nail-display-1-row'
      title.innerHTML = i.title
      const price = document.createElement('div')
      price.className = 'nail-price'
      price.innerHTML = '$' + (i.price / 100)
      const a = document.createElement('a')
      const aDiv = document.createElement('div')
      a.href = '/products/' + i.handle
      di.append(img)
      a.append(di)
      a.append(title)
      a.append(price)
      aDiv.append(a)
      const aa = document.createElement('div')

      aa.className = 'product-card'
      aa.setAttribute('data-json-product', JSON.stringify(i))
      aa.setAttribute('data-id', i.id)
      aa.innerHTML = this.createBtnCart(i)
      aDiv.append(aa)
      launchContent.append(aDiv)
    })
    box.append(launchContent)
  }
  createBtnCart (item) {
    return `
      <form action="/cart/add" method="post" class="variants" enctype="multipart/form-data" data-product-form2="">
        <input type="hidden" name="id" value="${item.variants[0].id}">
        <input type="hidden" name="quantity" value="1">
        <button data-btn-addtocart="" data-add-to-cart="" class="product-card__btn" type="submit" data-form-id="#list-product-form-6098224349363">
          <span class="hide" data-loader="">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path></svg>
          </span>
          <span data-add-to-cart-text="" class="">
            Add to bag
          </span>
        </button>
      </form>
    `
  }

  putAway() {
    const box = this.box.querySelector('.launch-box')
    box.style.display = 'none'
    box.innerHTML = ''
    this.box.querySelectorAll('.swiper-slide')[this.currentNumber].querySelector('.launch-icon').classList.remove('active')
    this.currentNumber = null
  }
}
